import React from 'react'

function ErrorPage() {
    return (
        <div>
            <h2>404 Page Not Found</h2>
            
        </div>
    )
}

export default ErrorPage

